import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { 
  Button, 
  Tabbar, 
  TabbarItem,
  NavBar,
  Grid,
  GridItem,
  Card,
  Image as VanImage,
  Icon,
  Tag,
  Cell,
  CellGroup,
  Field,
  Form,
  Toast,
  Loading,
  Checkbox,
  Uploader,
  Stepper,
  Radio,
  RadioGroup,
  Popup,
  Search,
  List,
  ActionSheet,
  Dialog
} from 'vant'
import 'vant/lib/index.css'

// 导入 Naive UI
import naive from 'naive-ui'
// 导入 ECharts
import * as echarts from 'echarts'
// 导入权限指令
import permission from './directives/permission'
// 通用字体
import 'vfonts/Lato.css'
// 等宽字体
import 'vfonts/FiraCode.css'
// 全局分页样式
import './styles/pagination.css'
// 统一管理页面UI样式
import './styles/unified-ui.css'
// 错误抑制样式
import './styles/error-suppression.css'
// 错误处理拦截器
import { setupWebpackErrorInterceptor, optimizeResizeObserver } from './utils/webpackErrorInterceptor'

// 设置错误拦截器
setupWebpackErrorInterceptor()

// 优化 ResizeObserver 性能
optimizeResizeObserver()

const app = createApp(App)

// 注册 Vant 组件
;[
  Button,
  Tabbar,
  TabbarItem,
  NavBar,
  Grid,
  GridItem,
  Card,
  VanImage,
  Icon,
  Tag,
  Cell,
  CellGroup,
  Field,
  Form,
  Toast,
  Loading,
  Checkbox,
  Uploader,
  Stepper,
  Radio,
  RadioGroup,
  Popup,
  Search,
  List,
  ActionSheet,
  Dialog
].forEach(component => {
  app.use(component)
})

app.use(store)
app.use(router)
app.use(naive)

// 注册权限指令
app.directive('permission', permission)

// 全局配置 ECharts
app.config.globalProperties.$echarts = echarts

app.mount('#app')